import { cn } from "@/lib/utils";

const statusConfig: Record<string, { label: string; className: string }> = {
  new: {
    label: "Yeni",
    className: "bg-accent/15 text-accent border-accent/30",
  },
  read: {
    label: "Okundu",
    className: "bg-info/15 text-info border-info/30",
  },
  replied: {
    label: "Yanıtlandı",
    className: "bg-success/15 text-success border-success/30",
  },
  completed: {
    label: "Tamamlandı",
    className: "bg-muted-foreground/15 text-muted-foreground border-muted-foreground/30",
  },
  // Turkish aliases
  yeni: {
    label: "Yeni",
    className: "bg-accent/15 text-accent border-accent/30",
  },
  okundu: {
    label: "Okundu",
    className: "bg-info/15 text-info border-info/30",
  },
  "yanıtlandı": {
    label: "Yanıtlandı",
    className: "bg-success/15 text-success border-success/30",
  },
  "tamamlandı": {
    label: "Tamamlandı",
    className: "bg-muted-foreground/15 text-muted-foreground border-muted-foreground/30",
  },
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status] || {
    label: status || "Yeni",
    className: "bg-secondary text-muted-foreground border-border",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
}
